import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addFilter({ dispatch, commit }, filter) {
    try {
      const { data } = await request.post('/filters', filter);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
